// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"ResourcePoolDetails_subTitle__3GIh7"};